import React, { Component } from "react";
import styled from "styled-components";
import { config } from "../config";
import { withRouter, Prompt } from "react-router-dom";
import { connect } from "react-redux";

import BlockLoader from "../components/BlockLoader";
import { SiteTemplate } from "../components/Site";

import { Field, reduxForm } from "redux-form";
import { renderInputWithLabel, renderDropzone } from "../components/Form";
import { FullWidthButton } from "../components/Form";

import { Row, Col } from "reactstrap";
import { toast } from "react-toastify";

import { required } from "../lib/validation";
import { maxLength } from "../lib/normalization";

import { updateAgency, get, uploadLogo } from "../settings/actions";

const maxLength90 = maxLength(90);
const maxLength200 = maxLength(200);

class Form extends Component {
  componentDidMount = async () => {
    const { reset, get, viewer } = this.props;
    reset();

    if (viewer) {
      const uid = viewer && viewer.agencyUID;
      get(uid);
    }
  };

  componentWillReceiveProps(nextProps) {
    const { get, viewer } = this.props;
    if (!viewer && nextProps.viewer) {
      const uid = nextProps.viewer.agencyUID;
      get(uid);
    }
  }

  submit = values => {
    const { updateAgency, get, viewer } = this.props;
    const uid = viewer.agencyUID;
    return updateAgency(values, uid).then(() => {
      toast.success("Ustawienia zostały zaktualizowana!");
      get(uid);
    });
  };

  onDrop = async files => {
    const { uploadLogo, change } = this.props;

    const rs = await uploadLogo(files);
    if (rs) {
      change("logoFileUID", rs.data.uid);
      change("logoFilePreview", files[0].preview);
    }
  };

  clearDropzone = e => {
    const { obj, change } = this.props;
    e.stopPropagation();
    change(
      "logoFilePreview",
      `${config.apiHost}/v1/agency/image/${obj.get("logoFileUID")}`
    );
    change("logoFileUID", obj.get("logoFileUID"));
  };

  render() {
    const {
      handleSubmit,
      submitting,
      dirty,
      error,
      agencies,
      viewer
    } = this.props;

    const uid = viewer && viewer.agencyUID;

    return (
      <SiteTemplate title="Dane agencji">
        <Prompt when={dirty} message="" />
        <BlockLoader isLoading={!viewer || !agencies.get(uid)}>
          <StyledForm onSubmit={handleSubmit(this.submit)}>
            <StyledRow>
              <Col xs="6">
                <Field
                  name="name"
                  component={renderInputWithLabel}
                  label="Nazwa agencji"
                  type="text"
                  placeholder="Nazwa agencji"
                  autoFocus
                  validate={[required]}
                  normalize={maxLength90}
                />
                <Field
                  name="description"
                  component={renderInputWithLabel}
                  label="Krótki opis agencji"
                  type="textarea"
                  placeholder="Krótki opis agencji"
                  normalize={maxLength200}
                />
              </Col>
              <Col xs="6">
                <Field
                  name="agencyUrl"
                  component={renderInputWithLabel}
                  label="Strona WWW"
                  type="text"
                  placeholder="Strona WWW agencji"
                  validate={[required]}
                />
                <Field
                  name="logoFilePreview"
                  component={renderDropzone}
                  onDrop={this.onDrop}
                  clearDropzone={this.clearDropzone}
                />
              </Col>
            </StyledRow>
            <Row>
              <Col xs="12">
                {error && <Error>{error}</Error>}

                <FullWidthButton
                  block
                  loading={submitting}
                  color={dirty ? "warning" : "primary"}
                  type="submit"
                >
                  Aktualizuj dane
                </FullWidthButton>
              </Col>
            </Row>
          </StyledForm>
        </BlockLoader>
      </SiteTemplate>
    );
  }
}

const StyledForm = styled.form``;

const StyledRow = styled(Row)`padding: 20px 20px 0px;`;

const Error = styled.div.attrs({ className: "text-danger" })`
  width: 100%;
  font-size: 12px;
  margin-bottom: 20px;
`;

Form = reduxForm({
  form: "settingsForm",
  destroyOnUnmount: false,
  enableReinitialize: true,
  initialValues: {}
})(Form);

Form = connect(
  (state, ownProps) => {
    let { initialValues } = ownProps;
    const viewer = state.auth.viewer;
    const agencies = state.entities.get("agencies");

    let obj;
    if (viewer) {
      const uid = viewer.agencyUID;

      obj = agencies.get(uid);

      if (obj) {
        const data = obj.toJS();
        initialValues = data;

        if (data.logoFileUID) {
          initialValues.logoFilePreview = `${config.apiHost}/v1/agency/image/${data.logoFileUID}`;
        }
      }
    }

    return { obj, agencies, viewer, initialValues };
  },
  {
    updateAgency,
    get,
    uploadLogo
  }
)(Form);

Form = withRouter(Form);

export default Form;



// WEBPACK FOOTER //
// ./src/settings/Form.js